import React from "react";
import * as Tabs from "@radix-ui/react-tabs";

/**
 * Reusable tab-triggers for the CoacheeDetailPage hierarchy of tabs.
 * `TabTrigger` is for the outermost row (Info / CV en Profielen / Tests
 * / Verslaglegging). `SubTabTrigger` is for the chip-style sub-tabs
 * inside the CV-Profielen and Tests panels.
 */
export function TabTrigger({ value, children, testid }) {
  return (
    <Tabs.Trigger
      value={value}
      data-testid={testid}
      className="px-4 py-2.5 text-sm font-medium text-zinc-600 border-b-2 border-transparent data-[state=active]:text-zinc-900 data-[state=active]:border-zinc-900 transition-colors"
    >
      {children}
    </Tabs.Trigger>
  );
}

export function SubTabTrigger({ value, children, testid }) {
  return (
    <Tabs.Trigger
      value={value}
      data-testid={testid}
      className="px-3 py-1.5 text-sm font-medium text-zinc-600 rounded-sm hover:text-zinc-900 data-[state=active]:bg-white data-[state=active]:text-zinc-900 data-[state=active]:shadow-sm transition-colors"
    >
      {children}
    </Tabs.Trigger>
  );
}
